export enum KeyboardKey {
  Comma = ',',
  Enter = 'Enter',
  Tab = 'Tab',
}
